import { StorageOracleService } from './../../../../../core/services/storage-oracle.service';
import { HeaderService } from './../../../../../core/services/header.service';
import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { tap } from 'rxjs';
import { CloudTypes, FileTypes } from 'src/app/core/models/globals';
import { StorageService } from 'src/app/core/services/storage.service';
import { StoreExplorerComponent } from '../store-explorer/store-explorer.component';
import { DeploymentService } from 'src/app/core/services/deployment.service';
import { HttpClient } from '@angular/common/http';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilityService } from 'src/app/core/services/utility.service';
import { AwsCloudService } from '../../../../../core/services/aws-cloud.service';

@Component({
	selector: 'app-file-editor',
	templateUrl: './file-editor.component.html',
	styleUrls: ['./file-editor.component.scss']
})
export class FileEditorComponent implements OnInit {

	fileName: string = "";
	depName: string = this.data.depName;
	cloudType: string = this.data.cloudType;
	filePath: string = this.data.filePath;
	toogleDialog: boolean = false;
	toogleFullScreen: boolean = false;
	searchTerm: string;
	totalWordCount: number = 0;
	curvalue: number = 0;
	currentWordIndex: number = 0;
	totalElements: number;
	regexCode: string = 'gi';
	isSensitiveTitle: string = 'case-insensitive';
	isSensitive: boolean = false;
	autoScroll: boolean = false;
	disableScrollDown: boolean = false;
	findExppr;
	openReplace: boolean = false;
	heading: string = "";
	isDarkMode: boolean = true;
	spinnerActive: boolean = false;

	@ViewChild('jobEditor', { static: true }) jobEditorElement: ElementRef;

	editorForm: UntypedFormGroup = new UntypedFormGroup({
		content: new UntypedFormControl("", [Validators.required]),
		fileName: new UntypedFormControl("", [Validators.required])
	})

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { 
			depName: string, 
			cloudType: string,
			filePath: string
			headNodeIp: string,
      nodeName: string,
      routeViaSynchpc: boolean
		},
		public dialogRef: MatDialogRef<FileEditorComponent>,
		private dialog: MatDialog,
		private _storageService: StorageService,
		private _headerService: HeaderService,
		private _oracleService: StorageOracleService,
		private awsService: AwsCloudService,
		private myElement: ElementRef, private deploymentService: DeploymentService,
		private _http: HttpClient, 
		private envs: EnvironmentService, 
		private _snackBar: MatSnackBar,
		private utilityService: UtilityService,
		public _spinner: NgxSpinnerService,
	) { }

	ngOnInit(): void {
		this.getFileContent(this.filePath);
		if (this.filePath != null) {
			if(!FileTypes.checkIfText(this.filePath,this.envs.envVariables.TextFileExtension)){
				this.dialogRef.close(false);
				this._snackBar.open("File Can't be Edited. ( NOT A TEXT FILE )", "Ok", { duration: 3000 });
				return;
			}

			this.heading = "Edit File";
		}
		else {
			this.heading = "Create File";
		}
		this.utilityService.checkIfUtilityServiceActive(this.data.headNodeIp, this.depName)
			.subscribe(data => this.isServiceActive = data);
	}

	onCancel(){
		this.dialogRef.close(false);
	}

	updateVar(){
		this.editorForm.controls["content"].setValue(this.jobEditorElement.nativeElement.innerText);
	}

	replaceChar(val: string){
		if(val){
			const re = new RegExp(this.searchTerm, this.regexCode);
			this.editorForm.controls["content"].setValue(this.editorForm.controls["content"].value.replace(re, val));
		}
	}

	onSubmit(){
		this.clearSearch();
		this.updateVar();
		let fileType = this.fileName.split(".").slice(1).join("");
		let myBlob = new Blob([this.editorForm.value.content + "\n"], { type: fileType });
		let file = new File([myBlob], `${this.fileName}`, { type: "text/plain", lastModified: this._headerService.getUserNewDate().getTime() });
		this.dialogRef.close(file);
	}

	getJobElementText(){
		let elementVal = this.jobEditorElement.nativeElement.innerText;
		return elementVal;
	}

	toogleDialogMinMax(){
		if(this.toogleFullScreen && !this.toogleDialog) { this.onFullScreen() }
		if(this.toogleDialog == false){
			this.toogleDialog = true;
			let element = document.querySelector('.file-editor-dialog');
			element.classList.add('minimize2');
		} else {
			this.toogleDialog = false;
			let element = document.querySelector('.file-editor-dialog');
			element.classList.remove('minimize2');
		}
	}

	onFullScreen(){
		if(this.toogleDialog){ this.toogleDialogMinMax() }
		let element = document.querySelector('.file-editor-dialog');
		if(!this.toogleFullScreen){
			element.classList.add('fullScreen');
		} else {
			element.classList.remove('fullScreen');
		}
		this.toogleFullScreen = !this.toogleFullScreen;
	}

	loadSyncStoreFileTree() {
		this.dialog
			.open(StoreExplorerComponent, {
				width: '50%',
				height: '70%',
				autoFocus: false,
				disableClose: true,
				data: { depName: this.depName, cloudType: this.cloudType },
			})
			.afterClosed()
			.subscribe((response) => {
				if (response) {
					this.showSpinner();
				}
			});
	}

	getFileContent(filePath: string){
		if(!filePath) return;
		this.showSpinner();
		
		if(this._headerService.getCloudNameForDeployment(this.data.depName) == CloudTypes.Oracle){
			this._oracleService.viewFileData(this._headerService.getStorageNameForDeployment(this.data.depName), filePath)
			.pipe(tap(d => this.hideSpinner()))
			.subscribe({
				next: (data) => {
					this.editorForm.controls["content"].setValue(data.toString());
					let fileName = filePath.split("/");
					this.fileName = fileName[fileName.length - 1];
				}, error: (err) => {
				}
			})
		}
		else if (this._headerService.getCloudNameForDeployment(this.data.depName) == CloudTypes.AWS) {
			this.awsService.viewFileData(this.data.depName, this._headerService.getStorageNameForDeployment(this.data.depName), filePath)
				.pipe(tap(d => this.hideSpinner()))
				.subscribe({
					next: (data) => {
						this.editorForm.controls["content"].setValue(data.toString());
						let fileName = filePath.split("/");
						this.fileName = fileName[fileName.length - 1];
					}, error: (err) => {
					}
				})
		} else {
			let pageData = {
				totalLines: -2,
				pageSize: 1000,
				currentIndex: -1,
			}
			this._storageService
				.viewFileData(
					this.data.depName,
					filePath, this.data.nodeName, pageData, false
				)
				.pipe(tap(d => this.hideSpinner()))
				.subscribe({
					next: (data: any) => {
						if(!data || !data.FileData) return;
						this.editorForm.controls["content"].setValue(data.FileData.toString().split("<br />").join("\n"));
						// this.renderer.setProperty(this.jobEditorElement.nativeElement, 'innerHTML', data.toString().split("<br />").join("\n"))
						let fileName = filePath.split("/");
						this.fileName = fileName[fileName.length - 1];
					}
				})
		}
	}

	searchKeyword(value: string) {
		this.searchTerm = value
		if (this.searchTerm == undefined || this.searchTerm.length == 1 && this.searchTerm == '.') {
		} else {
			if (this.searchTerm == '' || this.searchTerm == undefined) {
				this.clearSearch()
			} else {
				this.findExppr = new RegExp(value, this.regexCode)
				this.totalWordCount = (this.jobEditorElement.nativeElement.innerText.match(this.findExppr) || []).length
				this.autoScroll = false;
			}
			if (this.totalWordCount != 0 && this.currentWordIndex == 0) {
				this.currentWordIndex = 1;
			}
			if (this.totalWordCount == 0) {
				this.currentWordIndex = 0;
			}
		}
	}

	makeCaseSensitive() {
		this.isSensitive = !this.isSensitive;
		this.autoScroll = false;
		if (this.isSensitive == true) {
			this.regexCode = 'g'
			this.isSensitiveTitle = 'case-sensitive'
		} else {
			this.regexCode = 'gi'
			this.isSensitiveTitle = 'case-insensitive'
		}
		// this.editorForm.value.content = this.editorForm.value.content + ''
		this.searchKeyword(this.searchTerm)
	}

	clearSearch() {
		const dom: HTMLElement = this.myElement.nativeElement;
		dom.querySelectorAll('.marked').forEach(mark => {
			mark.setAttribute("style", "background-color: ''")
		})
		this.searchTerm = '';
		this.totalWordCount = 0;
		this.curvalue = 0;
		this.currentWordIndex = 0
		this.regexCode = 'gi'
		this.isSensitive = false;
		this.autoScroll = false;
	}

	removeAttrrStyle(dom) {
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #fcf8e3")
	}

	findNext() {
		this.autoScroll = false;
		const dom: HTMLElement = this.myElement.nativeElement;
		this.removeAttrrStyle(dom)
		this.curvalue = this.curvalue + 1;
		this.currentWordIndex = this.currentWordIndex + 1
		if (this.curvalue == this.totalWordCount) {
			this.curvalue = 0
			this.currentWordIndex = this.curvalue + 1
		}
		this.totalElements = dom.querySelectorAll('.marked').length
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0;")
		dom.querySelectorAll('.marked')[this.curvalue].scrollIntoView();
	}

	findPrevious() {
		this.autoScroll = false;
		const dom: HTMLElement = this.myElement.nativeElement;
		this.removeAttrrStyle(dom)
		this.curvalue = this.curvalue - 1;
		this.currentWordIndex = this.currentWordIndex - 1
		if (this.currentWordIndex == 0) {
			this.curvalue = this.totalWordCount - 1
			this.currentWordIndex = this.totalWordCount;
		}
		this.totalElements = dom.querySelectorAll('.marked').length
		dom.querySelectorAll('.marked')[this.curvalue].setAttribute("style", "background-color: #ff0");
		dom.querySelectorAll('.marked')[this.curvalue].scrollIntoView();
	}

	isServiceActive: boolean = false;
	isUtilityServiceActive(){
		if(this.cloudType != CloudTypes.OnPremise){
			this.isServiceActive = true;
			return
    }
    let url = this.deploymentService.getUrlForUtilityService(this.depName, this.data.headNodeIp, this.envs.envVariables.UtilityAccessPort, 0, this.data.routeViaSynchpc);
		this._http.get(url, { responseType: "text" }).subscribe({
			next: (data) => {
				this.isServiceActive = true;
			},
			error: (err) => {
				this.isServiceActive = false;
				this._snackBar.open("Utility service not active.", "Ok");
			}
		})
	}

	showSpinner(){
		this.spinnerActive = true;
  		return this._spinner.show('fileEditor');
	}

	hideSpinner(){
		this.spinnerActive = false;
		return this._spinner.hide('fileEditor');
	}
	
}
